module.exports = __webpack_public_path__ + "static/media/p-3.28741a4d.png";